'use client';

import { L } from '@salesport/logger';

import { config } from '../config';
import { Gtag } from '../types';

const logGAWarning = (message: string) => {
  L.instance.warn(message);
};

const getGtag = () => {
  if (!window.gtag) {
    logGAWarning('GTag does not exist or not initialzed yet');
  }
  return window.gtag;
};

const withGtag = (callback: (gtag: Gtag.Gtag) => void) => {
  const gtag = getGtag();
  if (!gtag) return;
  callback(gtag);
};

export const sendGtagEvent = <T extends Gtag.Event>(event: T) =>
  withGtag((gtag) => {
    gtag('event', event.action, event.params);
  });

export const getGtagClientId = async () => {
  const gtag = getGtag();
  return new Promise<string | undefined>((resolve, reject) => {
    if (!gtag) {
      return reject('GTag is not initialized');
    }
    gtag('get', config.gaId, 'client_id', (value) => {
      resolve(value);
    });
  });
};

export const tryGetGtagClientId = async () => {
  try {
    return await getGtagClientId();
  } catch (error) {
    return undefined;
  }
};

export const setGtagUserId = (id?: string) =>
  withGtag((gtag) => {
    gtag('set', { user_id: id });
  });

export const grantGtagConsent = (pref: Gtag.ConsentPreferences) =>
  withGtag((gtag) => {
    gtag('consent', 'update', {
      ad_user_data: pref.ad_user_data,
      ad_personalization: pref.ad_personalization,
      ad_storage: pref.ad_storage,
      analytics_storage: pref.analytics_storage,
    });
  });

export const grantGtagConsentForEverything = () =>
  grantGtagConsent({
    ad_personalization: 'granted',
    ad_storage: 'granted',
    ad_user_data: 'granted',
    analytics_storage: 'granted',
  });

export const markFeatureUsage = (feature: string) =>
  performance.mark('mark_feature_usage', {
    detail: { feature },
  });
